<template>
    <div class="d-flex h-100">
        <div v-if="activeSlide" class="d-flex flex-column w-100 overflow-auto">
            <div class="flex-grow-1 position-relative">
                <transition-group name="slide" :enter-class="slideOffset < 0 ?'slide-right-position':'slide-left-position'"
                            :leave-to-class="slideOffset < 0 ?'slide-left-position':'slide-right-position'">
                  <template v-for="slide in slides">
                    <Slide
                        v-if="slide.id === activeSlide.id"
                        :slide="slide"
                        :active="slide.id === activeSlide.id"
                        :key="slide.id"
                    />
                  </template>
                </transition-group>
            </div>
        </div>
        <div v-else class="col min-vh-100" style="background: rgba(0,0,0,0.5)">
            <button class="btn d-lg-none text-light float-end m-3" type="button" @click.prevent="$emit('showNav')">
                <i class="fas fa-bars"></i>
            </button>
            <div class="d-flex vh-100 justify-content-center align-items-center">
                <div class="text-center text-white p-2">
                    <h3>{{ $t('js.slide_show.no_slide_active') }}</h3>
                    <p>{{ $t('js.slide_show.presentation_not_started') }}</p>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import Slide from "../../frontend/observer/Slide.vue"
    import {mapGetters, mapState} from "vuex"

    export default {
        name: "SlideTab",
        components: {Slide},
        computed: {
            ...mapState(['slides', 'slideOffset']),
            ...mapGetters(['activeSlide']),
        }
    }
</script>